// extracted by mini-css-extract-plugin
module.exports = {"fullWidth":"_3jxJqC"};